module.exports = "<a (click)=\"navigate($event)\">{{item.name}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/side-menu/drop-menu-item/drop-menu-item.component.html
// module id = 1835
// module chunks = 0